const SelectionGroup = ({ children, title }) => {
	return (
		<div className="pt-3">
			{title && <h2 className="h-without-default-style mb-2">{title}</h2>}
			{children}
		</div>
	)
}

export { SelectionGroup }
